export default [
  {
    path: '/mission-rewards',
    component: () => import('./views/Index'),
    name: 'mission-rewards',
    redirect: { name: 'mission-reward-list' },
    children: [
      {
        path: '',
        name: 'mission-reward-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'detail/:reward_id',
        name: 'mission-reward-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
